import React from "react";
import TrinsicStart from "../trinsic/TrinsicStart";
import FinnishTrustNetworkLogo from "../../../assets/finnish_trust_network.svg";
import {
  IconBolt,
  IconLock,
  IconHeart,
} from "@tabler/icons-react";
import useLocale from "../../../hooks/useLocale";

const FinnishTrustNetworkStart = () => {
  const locale = useLocale("finnish-trust-network");

  const finnishFeatures = [
    { icon: IconBolt, text: locale.features.feature1 },
    { icon: IconLock, text: locale.features.feature2 },
    { icon: IconHeart, text: locale.features.feature3 },
  ];

  return (
    <TrinsicStart
      providerName="FINNISH_TRUST_NETWORK"
      providerDisplayName="Finnish Trust Network"
      logo={FinnishTrustNetworkLogo}
      logoWidth={50}
      title={locale.title}
      features={finnishFeatures}
      poweredByText={locale.poweredBy}
      getStartedText={locale.getStarted}
    />
  );
};

export default FinnishTrustNetworkStart;
